import { useQuery } from '@tanstack/react-query'
import { authApi } from 'shared/api/auth'

export interface GetRefreshTokensRequest {
  userId?: number
}

export interface GetRefreshTokensResponse {
  code: number
  data: {
    browser: string
    created_at: string
    device: string
    expires_at: string
    id: number
    ip_address: string
    last_used: null | string
    location: string
    token: string
    updated_at: string
    user_agent: string
    user_id: number
  }[]
}

const getRefreshTokens = async (params?: GetRefreshTokensRequest) => {
  const { userId } = params || {}
  const response = await authApi.get<GetRefreshTokensResponse>(
    '/refresh-tokens',
    { params: { user_id: userId } }
  )

  return response.data.data
}

export const useGetRefreshTokens = (params?: GetRefreshTokensRequest) => {
  const query = useQuery({
    queryKey: ['refreshTokens'],
    queryFn: () => getRefreshTokens(params)
  })

  return { query }
}
